module.exports = __webpack_public_path__ + "media/components/util/logos/vecteezy-logo--black-6ae63b24255cecc610e8a1004514baf9.svg";